import React from 'react';

const fieldStyle: React.CSSProperties = {
  width: '100%',
  background: 'var(--surface-2)',
  border: '1px solid var(--border)',
  borderRadius: 'var(--radius-md)',
  color: 'var(--text-primary)',
  padding: '8px 11px',
  fontSize: 13.5,
  fontFamily: 'var(--font-sans)',
  outline: 'none',
};

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

/** Design-system text input. */
export const Input = React.forwardRef<HTMLInputElement, InputProps>(({ style, className = '', ...rest }, ref) => (
  <input
    ref={ref}
    className={`focus:border-[var(--lime)] focus:ring-1 focus:ring-[var(--lime)] transition-colors ${className}`}
    style={{ ...fieldStyle, ...style }}
    {...rest}
  />
));
Input.displayName = 'Input';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

/** Design-system textarea. */
export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ style, className = '', ...rest }, ref) => (
  <textarea
    ref={ref}
    className={`focus:border-[var(--lime)] focus:ring-1 focus:ring-[var(--lime)] transition-colors ${className}`}
    style={{ ...fieldStyle, resize: 'vertical', ...style }}
    {...rest}
  />
));
Textarea.displayName = 'Textarea';

export default Input;
